import type { Auth0Client } from '@auth0/auth0-spa-js';
import { createAuth0Client } from '@auth0/auth0-spa-js';

export async function startAuth0Redirect(opts: {
  domain: string;
  audience?: string;
  scope: string;
  callbackUrl: string;
  clientId: string;
  appState: {
    source: 'ot-login';
    returnTo: string;
    incoming: Record<string, string>;
  };
}) {
  const { domain, clientId, audience, scope, callbackUrl, appState } = opts;

  const authorizationParams: Record<string, string> = {
    redirect_uri: callbackUrl,
    response_type: 'code',
    scope,
    ...(audience ? { audience } : {}),
    screen_hint: 'signup',
    connection: 'Self-Serve-Signup',
    prompt: 'login',
    'ext-brand': 'opentable',
  };

  const auth0: Auth0Client = await createAuth0Client({
    domain,
    clientId,
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    authorizationParams,
  });

  await auth0.loginWithRedirect({ appState });
}
